import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Typography from '@material-ui/core/Typography';
import {styles} from './styles';
import DatePicker from '../../common/datePicker';
import CheckList from '../../common/checkList';
import TextBox from '../../common/textBox';
import RadioList from '../../common/radioGroup';
import YesNo from '../../common/yesNo';
import ConfirmationDialog from '../../common/confirmationDialog';
import Range from '../../common/range';
import DateRange from '../../common/dateRange';
import ImagePicker from '../../common/imagePicker';
import ImagePickerMultiple from '../../common/imagePickerMultiple';

export class Attributes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.renderAttributes = this.renderAttributes.bind(this);
    this.renderAnswer = this.renderAnswer.bind(this);
    this.renderButton = this.renderButton.bind(this);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.handleEditAttributes = this.handleEditAttributes.bind(this);
    this.handleSoldUnit = this.handleSoldUnit.bind(this);
    this.handleUnSoldUnit = this.handleUnSoldUnit.bind(this);
    this.handleChangeSoldUnit = this.handleChangeSoldUnit.bind(this);
  }

  handleGoBack() {
    window.scrollTo(0, 0);
    this.props.onGoBack();
  }

  handleUnSoldUnit() {
    const {unit} = this.props;
    this.props.onSetUnSold(unit.id);
  }

  handleSoldUnit() {
    const {unit} = this.props;
    this.props.onSetSold(unit.id);
  }

  handleChangeSoldUnit(e) {
    const {checked} = e.target;
    if (checked === true) {
      this.handleUnSoldUnit();
    } else {
      this.handleSoldUnit();
    }
  }

  dateAnswer(identifier, currentAnswer, isBirthdate, content, permissions) {
    return (
      <DatePicker 
        isBirthdate={isBirthdate} 
        updateAnswer={this.props.onUpdateAnswer} 
        content={content}
        currentAnswer={currentAnswer}
        identifier={identifier}
        permissions={permissions}
      />
    );
  }

  textAnswer(identifier, currentAnswer, permissions) {
    return (
      <TextBox 
        updateAnswer={this.props.onUpdateAnswer} 
        placeholder="Ingrese..."
        currentAnswer={currentAnswer}
        identifier={identifier}
        permissions={permissions}
      />
    );
  }

  yesNoAnswer(identifier, currentAnswer, permissions) {
    return (
      <YesNo 
        identifier={identifier}
        currentAnswer={currentAnswer}
        updateAnswer={this.props.onUpdateAnswer} 
        permissions={permissions}
      />
    );
  }

  imagePickerUnique(identifier, currentAnswer, answers, permissions) {
    return (
      <ImagePicker 
        identifier={identifier}
        currentAnswer={currentAnswer}
        answers={answers} 
        updateAnswer={this.props.onUpdateAnswer} 
        permissions={permissions}
      />
    );
  }

  imagePickerMultiple(identifier, currentAnswer, answers, permissions) {
    return (
      <ImagePickerMultiple 
        identifier={identifier}
        currentAnswer={currentAnswer}
        answers={answers} 
        updateAnswer={this.props.onUpdateAnswer} 
        permissions={permissions}
      />
    );
  }

  radioGroup(identifier, currentAnswer, answers, permissions) {
    return (
      <RadioList 
        answers={answers} 
        currentAnswer={currentAnswer}
        identifier={identifier}
        updateAnswer={this.props.onUpdateAnswer}
        permissions={permissions}
      />
    );
  }

  checkList(identifier, currentAnswer, answers, permissions) {
    return (
      <CheckList 
        answers={answers}
        currentAnswer={currentAnswer}
        identifier={identifier} 
        updateAnswer={this.props.onUpdateAnswer}  
        permissions={permissions}
      />
    );
  }

  range(identifier, currentAnswer, answers, permissions) {
    return (
      <Range 
        identifier={identifier}
        answers={answers} 
        currentAnswer={currentAnswer}
        updateAnswer={this.props.onUpdateAnswer} 
        permissions={permissions}
      />
    );
  }

  dateRange(identifier, currentAnswer, permissions) {
    return (
      <DateRange
        identifier={identifier} 
        currentAnswer={currentAnswer}
        updateAnswer={this.props.onUpdateAnswer} 
        permissions={permissions}
      />
    );
  }

  handleEditAttributes() {
    window.scrollTo(0, 0);
    this.props.onEditAttributes();
  }

  renderAttributes() {
    const {attributes, classes} = this.props;
    return attributes.map((attribute, index) => {
      return (
        <div key={index}>
          <div className={classes.questionContainer}>
            <Typography variant="subtitle1">
              {attribute.name}
            </Typography>
            {this.renderAnswer(attribute)}
          </div>
          <Divider />
        </div>
      );
    });
  }

  renderButton() {
    const {isLoading, classes, permissions} = this.props;
    
    if (permissions) {
      if (!isLoading) {
        return (
          <ConfirmationDialog 
            confirmationText="¿Está seguro que desea actualizar esta unidad?"
            buttonText="Modificar unidad"
            variant="contained"
            isDisabled={false}
            confirmAction={this.handleEditAttributes}
          />
        );
      }
      return <CircularProgress className={classes.progress} />;
    }
    return null;
  }

  renderAnswer(attribute) {
    const {unit, permissions} = this.props;
    const {identifier} = attribute;
    const currentAnswer = unit.attributes[identifier];
    switch (attribute.input_type) {
    case 'date':
      return this.dateAnswer(identifier, currentAnswer, false, permissions);
    case 'birth_date':
      return this.dateAnswer(identifier, currentAnswer, true, permissions);
    case 'text_box':
      return this.textAnswer(identifier, currentAnswer, permissions);
    case 'yes_no':
      return this.yesNoAnswer(identifier, currentAnswer, permissions);
    case 'image_unique':
      return this.imagePickerUnique(identifier, currentAnswer, attribute.options.content, permissions);
    case 'image_multiple':
      return this.imagePickerMultiple(identifier, currentAnswer, attribute.options.content, permissions);
    case 'radio_group':
      return this.radioGroup(identifier, currentAnswer, attribute.options.content, permissions);
    case 'check_list':
      return this.checkList(identifier, currentAnswer, attribute.options.content, permissions);
    case 'range':
      return this.range(identifier, currentAnswer, attribute.options.content, permissions);
    case 'date_range':
      return this.dateRange(identifier, currentAnswer, permissions);
    default:
      return null;
    }
  }

  render() {
    const {classes, isLoading, unit, permissions} = this.props;
    console.log('unit: ', unit);
    const unitName = unit.name ? unit.name : '';
    return isLoading === true ? <CircularProgress style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto'}} /> : (
      <Paper elevation={2} className={classes.paperRoot}>
        <Toolbar>
          <IconButton onClick={this.handleGoBack}>
            <ArrowBackIosIcon />
          </IconButton>
          <Typography variant="h6">
            {`Atributos de la unidad ${unitName}`}
          </Typography>
        </Toolbar>
        <div className={classes.attributesContainer}>
          <div className={classes.questionContainer}>
            <FormControlLabel
              control={
                <Switch
                  checked={unit.availability.status === 'available'}
                  onChange={this.handleChangeSoldUnit}
                  disabled={permissions === false}
                  color="primary"
                />
              }
              label="Unidad disponible"
            />
          </div>
          <Divider />
          <div className={classes.questionContainer}>
            <Typography variant="subtitle1">
              Descripción de la unidad: 
            </Typography>
            <TextField 
              fullWidth
              autoFocus
              placeholder="Ingrese descripción"
              variant="outlined"
              disabled={permissions === false}
              multiline
              value={unit.description}
              onChange={this.props.onEditDescription}
            />
          </div>
          <Divider />
          {this.renderAttributes()}
        </div>
        <div className={classes.submitContainer}>
          {this.renderButton()}
        </div>
      </Paper>
    );
  }
}

Attributes.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  permissions: PropTypes.bool.isRequired,
  unit: PropTypes.object.isRequired,
  attributes: PropTypes.array.isRequired,
  onGoBack: PropTypes.func.isRequired,
  onUpdateAnswer: PropTypes.func.isRequired,
  onSetSold: PropTypes.func.isRequired,
  onSetUnSold: PropTypes.func.isRequired,
  onEditAttributes: PropTypes.func.isRequired,
  onEditDescription: PropTypes.func.isRequired
};
  
export default (withStyles(styles)(Attributes));
